<template>
  <ScrollComponent
    customTagSelector=".menuPannelContent"
    fillScrollBarMissingWithPadding
  />
  <div
    class="w-full h-full flex flex-col overflow-auto bg-[#121133] menuPannelContent"
  >
    <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
      contentId="subscription"
    />
    <div class="py-4"></div>
    <div class="flex px-8 items-center gap-4">
      <!-- <div class="w-14 h-14 overflow-hidden rounded-2xl">
        <img src="/images/logo-bg.png" alt="" />
      </div> -->
      <div class="text-white inline-block relative">
        <span class="text-3xl font-bold">
          <span class="text-[#FE610C] mr-1">Eki</span
          ><span class="text-white">Discount</span>
        </span>
        <div
          class="text-primary bg-white absolute font-bold bottom-0 right-0 px-2 text-sm rounded-lg translate-y-1/2 translate-x-1/2"
        >
          Admin
        </div>
      </div>
    </div>
    <div class="py-2"></div>
    <div
      class="p-4 py-0"
      v-for="(nav, i) in navs"
      :key="i"
      :permission="nav.permission || 'none'"
      :class="[nav.cssClasses]"
    >
      <component
        :is="nav.path ? 'router-link' : 'div'"
        :to="nav.path"
        class="flex p-4 items-center gap-4 ripple rounded-xl duration-300"
        @click="selectNav(nav)"
        :class="[
          {
            '  bg-[#F1AE1B] text-white': isActive(nav),
            'text-[#f4f4f5]': !isActive(nav),
          },
        ]"
        v-if="!nav.content"
      >
        <div
          class="w-6 h-6 duration-300 text-white"
          :class="{
            'brightness-200': isActive(nav),
          }"
        >
          <img :src="nav.icon" alt="" class="w-full h-full" />
        </div>
        <div class="">
          {{ nav.name }}
        </div>
      </component>
    </div>
    <div class="py-4"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DataGetter from '../utils/DataGetter.vue'
import ScrollComponent from '../utils/ScrollComponent.vue'

export default defineComponent({
  name: 'MenuPannelContent',
  components: { DataGetter, ScrollComponent },
  props: {},
  data() {
    return {
      eventsIds: [],
      subscription: {},
      navs: [
        {
          name: 'Statistiques',
          icon: '/images/icons/dashboard-interface.svg',
          path: '/home',
          permission: 'dashboard',
        },
        {
          name: 'Boutiques',
          icon: '/images/icons/delivery-box.svg',
          path: '/stores',
          permission: 'stores',
        },
        {
          name: 'Produits',
          icon: '/images/icons/delivery-box.svg',
          path: '/products',
          permission: 'products',
        },
        {
          name: 'Commandes',
          icon: '/images/icons/purchase-order.svg',
          path: '/orders',
          permission: 'orders',
        },
        {
          name: 'Transactions',
          icon: '/images/icons/transaction-history.svg',
          path: '/payments',
          permission: 'payments',
        },
        {
          name: 'Chargebacks',
          icon: '/images/icons/refund.svg',
          path: '/chargebacks',
          permission: 'chargebacks',
        },
        {
          name: 'Transferts',
          icon: '/images/icons/transfer.svg',
          path: '/transfer',
          permission: 'transferts',
        },
        {
          name: 'Reversements',
          icon: '/images/icons/bank-_1_.svg',
          path: '/withdrawal',
          permission: 'withdrawals',
        },
        {
          name: 'Bannière',
          icon: '/images/icons/pictures.svg',
          path: '/website',
          permission: 'banner',
        },
        {
          name: 'Documents',
          icon: '/images/icons/folder.svg',
          path: '/documents',
          permission: 'documents',
        },
        {
          name: 'Equipe & Roles',
          icon: '/images/icons/management.svg',
          path: '/team',
          permission: 'team',
        },
        {
          name: 'Categories',
          icon: '/images/icons/list.svg',
          path: '/categories',
          permission: 'categories',
        },
        {
          name: 'Frais & Paiements',
          icon: '/images/icons/fee.svg',
          path: '/fees',
          permission: 'fees',
        },
        {
          cssClasses: 'mb-4',
          name: 'Configurations',
          icon: '/images/icons/settings.svg',
          path: '/configurations',
          permission: 'settings',
        },
        {
          cssClasses: 'mt-auto',
          name: 'Déconnexion',
          icon: '/images/icons/logout_1.svg',
          event: 'logout_requested',
        },
      ],
    }
  },
  mounted() {},
  methods: {
    selectNav(nav) {
      // if (nav.path) this.$router.push(nav.path).catch(() => {});
      if (nav.event) this.$Events.dispatchEvent(nav.event)
      else if (nav.onClick) nav.onClick()

      this.$emit('navClicked')
    },
    isActive(nav) {
      return this.$route.path == nav?.path
    },
  },
  watch: {},
})
</script>
